import { types } from './actions.js';

const initialState = { };

export default function reducer(state = initialState, action) {
  if (action.type === types.SET_VISIBILITY) {
    const nState = { ...state };
    if (!nState[action.group]) {
      nState[action.group] = {
        [action.name]: {
          visible: action.visible,
          top: action.top
        }
      };
    } else {
      nState[action.group] = { 
        ...nState[action.group],
        [action.name]: {
          visible: action.visible,
          top: action.top
        }
      }
    }
    
    return nState;
  }
  return state;
}